import { PatientPimsReminderFieldsFragment } from '~graphql/generated/graphql'

export function groupRemindersByReminderType(
    reminders: PatientPimsReminderFieldsFragment[],
): PatientPimsReminderFieldsFragment[] {
    return reminders.reduce((prev, curr) => {
        if (!curr.reminder_type) {
            const existing = prev.find(
                r => r.reminder_desc === curr.reminder_desc,
            )

            if (existing && existing.send_date) {
                if (existing.send_date > curr.send_date) {
                    return prev
                } else {
                    return prev.map(r => {
                        if (r.reminder_desc === curr.reminder_desc) {
                            return curr
                        } else {
                            return r
                        }
                    })
                }
            } else {
                return [...prev, curr]
            }
        }

        const existing = prev.find(
            r => r.reminder_type?.id === curr.reminder_type?.id,
        )

        if (existing && existing.send_date) {
            if (existing.send_date > curr.send_date) {
                return prev
            } else {
                return prev.map(r => {
                    if (r.reminder_type?.id === curr.reminder_type?.id) {
                        return curr
                    } else {
                        return r
                    }
                })
            }
        } else {
            return [...prev, curr]
        }
    }, [] as PatientPimsReminderFieldsFragment[])
}
